<template>
    <modal
            v-bind="$attrs"
            :transition='0'
            :append-to-body="true"
            :backdrop="false"
            :model-value="modelValue"
            @update:model-value="$emit('update:modelValue', $event)"
            @show="onShowed"
    >
        <template #header>
            <div>
                <slot name="header">

                </slot>
            </div>
        </template>
        <div>
            <slot></slot>
        </div>
        <template #footer>
            <div>
                <slot name="footer">

                </slot>
                <div class="row">
                    <div class="col-sm-12" style="line-height: 2px;">
                        <span tabindex="0" aria-hidden="true" class="focus-catch-link" @focus="$parent.focusToClose">&nbsp;</span>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
    export default {
        name: "BasicModal",
        /**
         * The 113 components that open a popup through this one write `v-model="opened"`,
         * and the open state has to reach uiv's <modal> below still spelled the vue 3 way.
         *
         * @vue/compat used to rewrite a component's `modelValue` + `update:modelValue`
         * back to vue 2's `value` + `input`, deciding it from the receiving component's own
         * compat config. Left as an ordinary vue 2 component, this one would have taken the
         * rewrite: `$attrs` would carry `value`, uiv 2 reads `modelValue`, and every modal
         * in the app would have stayed shut.
         *
         * So this component was the boundary where the app stopped being vue 2 - the first
         * to speak vue 3's v-model in both directions, and to forward it on explicitly
         * rather than letting it ride along in $attrs. The rest of the app followed, and
         * compat went with the last of them.
         */
        // `$attrs` carries the caller's @hide/@show as onHide/onShow, so the single
        // `v-bind="$attrs"` above forwards them to uiv - which is what a listener does under
        // plain vue 3, and what this component needed before the rest of the app did
        // $attrs is bound onto the modal by hand above, so it must not also be applied
        // automatically - that would set every attr twice
        inheritAttrs: false,
        props: {
            modelValue: {type: Boolean, default: false},
        },
        emits: ['update:modelValue'],
        methods: {
            onShowed() {
                this.$parent.ariaHideRestAndCatchFocus();
            },
        }
    };
</script>
